export const SITE_CODE_PATTERN = /^[a-z0-9][a-z0-9_-]{0,19}$/;

export const resolveSiteCode = (hostname = window.location.hostname) => {
  const host = String(hostname || "").toLowerCase();
  if (host.includes("biznavi") || host.includes("findbiz")) return "biznavi";
  return "ipnow";
};

export const SITE_COMPANY_INFO_DEFAULTS = {
  company_name: "주식회사 아이피나우",
  ceo_name: "황차동",
  corporate_reg_no: "180111-1360047",
  business_reg_no: "376-86-02011",
  hq_address: "(48480) 부산광역시 남구 신선로 2, 410호(우암동)",
  branch_address:
    "(06621) 서울특별시 서초구 강남대로53길 8 마이워크스페이스 타워, 7F",
  vietnam_address:
    "7th floor, Kailash building B21 - D21, Dich Vong Hau ward, Cau Giay distric, Ha Noi, Viet Nam",
  phone: "070-4249-1023",
  fax: "02-3463-2200",
  email: "ipnow@ipnow.co.kr",
  copyright: "ⓒ Copyright © 2024 IPNOW. All rights reserved.",
};

export const SITE_COMPANY_INFO_ROWS = [
  [
    { key: "company_name", label: "법인명" },
    { key: "ceo_name", label: "대표이사" },
    { key: "corporate_reg_no", label: "법인등록번호" },
    { key: "business_reg_no", label: "사업자등록번호" },
  ],
  [{ key: "hq_address", label: "본사" }],
  [{ key: "branch_address", label: "지사" }],
  [{ key: "vietnam_address", label: "베트남" }],
  [
    { key: "phone", label: "대표전화" },
    { key: "fax", label: "팩스" },
    { key: "email", label: "이메일" },
  ],
  [{ key: "copyright", label: "저작권 문구" }],
];
